import { render, staticRenderFns } from "./Vasilkov.vue?vue&type=template&id=0f42de59&"
import script from "./Vasilkov.vue?vue&type=script&lang=ts&"
export * from "./Vasilkov.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports